// extracted by mini-css-extract-plugin
export var printerCard = "_b7-1";
export var printerCardConfigured = "_b7-2";
export var printerCardError = "_b7-3";
export var printerCardsContainer = "_b7-0";
export var printerIcon = "_b7-8";
export var printerIconConfigured = "_b7-5";
export var printerIconContainer = "_b7-4";
export var printerIconError = "_b7-6";
export var printerIconUnconfigured = "_b7-7";
export var workstationsTableCard = "_b7-9";